<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="840px">
    <template v-slot:title>Add/Edit Departures</template>
    <v-row>
      <v-col>
        <dates-range
          :outlined="outlinedInputs"
          :gt-date-from-string="validFrom"
          :gt-date-to-string="validTo"
          @onRangeSelected="onDatesChange"
        ></dates-range>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          item-text="name"
          item-value="value"
          :outlined="outlinedInputs"
          label="Days of Week"
          :items="daysOfWeek"
          v-model="selectedDaysOfWeek"
          multiple
          chips
          deletable-chips
        ></v-select>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Save</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog";
import DatesRange from "../../shared/DatesRangePicker";

export default {
  name: "template-departure-dialog",

  props: {
    value: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    BasicDialog,
    DatesRange,
  },

  data() {
    return {
      debug: false,
      validFrom: "",
      validTo: "",
      daysOfWeek: [
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
        {
          name: "Sunday",
          value: "0",
        },
      ],
      selectedDaysOfWeek: [],
    };
  },

  computed: {
    isValid() {
      return (
        this.validFrom != "" &&
        this.validTo != "" &&
        this.selectedDaysOfWeek.length > 0
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    departure() {
      return {
        id: this.value && this.value.id != "" ? this.value.id : undefined,
        validFrom: this.validFrom,
        validTo: this.validTo,
        daysOfWeek: this.selectedDaysOfWeek.join(","),
      };
    },
  },

  watch: {
    value(newVal) {
      this.validFrom = newVal.validFrom;
      this.validTo = newVal.validTo;
      this.selectedDaysOfWeek = newVal.daysOfWeek
        ? newVal.daysOfWeek.split(",")
        : [];
    },
  },

  methods: {
    onSave() {
      this.$emit("input", { ...this.departure });
      this.$emit("save", { ...this.departure });
    },
    onDatesChange(payload) {
      if (payload.dateFrom) {
        this.validFrom = payload.dateFrom;
      }
      if (payload.dateTo) {
        this.validTo = payload.dateTo;
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/TemplateDepartureDialog.vue